import React, { ReactElement, ReactNode } from "react";
import styled from "@emotion/styled";
import { Box, Theme, useMediaQuery } from "@mui/material";

const Container = styled(Box)<{ collapsed: number; matches: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export interface SidebarMenuProps {
  collapsed?: boolean;
  children: ReactNode;
  className?: string;
}

export const SidebarMenu = ({
  children,
  className,
  collapsed = false,
}: SidebarMenuProps) => {
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(
        child as ReactElement<{ collapsed?: boolean }>,
        { collapsed }
      );
    }
    return child;
  });

  return (
    <Container
      className={className}
      collapsed={collapsed ? 1 : 0}
      matches={matches ? 1 : 0}
    >
      {childrenWithProps}
    </Container>
  );
};
